import React from 'react';

interface ILabeledBox {
  label: string;
  children: any;
}

export const LabeledBox = (props: ILabeledBox) => {
  const { label, children } = props;
  return (
    <div className="labeled-box">
      <p className="label">{label}</p>
      <div className="box">{children}</div>
    </div>
  );
};
